import { Component, Input, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { environment } from '@myenv/environment';

@Component({
  selector: 'app-coming-soon',
  standalone: true,
  imports: [],
  templateUrl: './coming-soon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./coming-soon.component.scss'],
})
export class ComingSoonComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly title = inject(Title);

  /** When true, fits inside a parent layout (e.g. device details tabs) instead of full page. */
  @Input() embedded = false;

  @Input() backgroundImageSrc = '';
  @Input() featureName = '';
  @Input() description = '';

  readonly illustrationSrc = 'assets/img/coming-soon-illustration.png';

  ngOnInit(): void {
    const data = this.route.snapshot.data;

    if (!this.featureName) {
      this.featureName =
        data['featureName'] ||
        this.route.snapshot.queryParamMap.get('feature') ||
        'This feature';
    }

    if (!this.backgroundImageSrc) {
      this.backgroundImageSrc = data['backgroundImageSrc'] || '';
    }

    if (!this.description) {
      this.description = data['description'] || '';
    }

    if (!this.embedded) {
      this.title.setTitle(`${this.featureName} | Coming Soon${environment.title_text}`);
    }
  }
}
